const salesDummy = [
  {
    name: "Government",
    net: 0,
  },
  {
    name: "Retail",
    net: 0,
  },
  {
    name: "Fleet",
    net: 0,
  },
  {
    name: "Value +",
    net: 0,
  },
  {
    name: "Internal",
    net: 0,
  },

  {
    name: "Repair Shop",
    net: 0,
  },
  {
    name: "Insurance",
    net: 0,
  },
  {
    name: "Branch",
    net: 0,
  },
];

const deptDummy = [
  { name: "Body Shop", net: 0 },
  { name: "Workshop", net: 0 },
  { name: "Fast Lane 1", net: 0 },
  { name: "Fast Lane 2", net: 0 },
  { name: "Fast Lane 3", net: 0 },
  { name: "Fast Lane 4", net: 0 },
];

const checkpoints: any = {
  "Service / Delivery Parking": 1,
  "Express Lane": 2,
  "Workshop 1": 3,
  "Workshop 2": 4,
  "Workshop 3": 5,
  "Washing Bay": 6,
  "Body and Paint Center": 7,
  "Testing Lane": 8,
  "Waiting for customer approval": 9,
};

const checknames: any = {
  "Service / Delivery Parking": "Delivery Parking",
  "Express Lane": "Express Lane",
  "Workshop 1": "Workshop 1",
  "Workshop 2": "Workshop 2",
  "Workshop 3": "Workshop 3",
  "Washing Bay": "Washing Bay",
  "Body and Paint Center": "Body & Paint",
  "Testing Lane": "Testing Lane",
  "Waiting for customer approval": "Waiting Approval",
};

// switch (item?.station?.name) {
//   case "Service / Delivery Parking":
//     acc[stationId].order = 1;
//     break;
//   case "Express Lane":
//     acc[stationId].order = 2;
//     break;
//   case "Workshop 1":
//     acc[stationId].order = 3;
//     break;
//   case "Workshop 2":
//     acc[stationId].order = 4;
//     break;
//   case "Workshop 3":
//     acc[stationId].order = 5;
//     break;
//   case "Washing Bay":
//     acc[stationId].order = 6;
//     break;
//   case "Body and Paint Center":
//     acc[stationId].order = 7;
//     break;
//   case "Testing Lane":
//     acc[stationId].order = 8;
//     break;
//   case "Waiting for customer approval":
//     acc[stationId].order = 9;
//     break;
// }

export { salesDummy, deptDummy, checknames, checkpoints };
